'use strict';

module.exports = {
  currentPage: null,
  itemState: {},
  datasetsCount: 0,
  tartanPreview: {
    isVisible: false
  },
  downloadFiles: {
    isVisible: false
  },
  pages: []
};



//////////////////
// WEBPACK FOOTER
// ./src/scripts/application/store/state.js
// module id = 181
// module chunks = 0